/* global Plotly:true */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Loader from 'react-loader';
import createPlotlyComponent from 'react-plotly.js/factory';

// import Table from './Table';
// import Controls from './Controls';
import Button from './Button';

import { processFiles } from "../redux/graph-actions";

const Plot = createPlotlyComponent(Plotly); 

class GraphDisplay extends Component {
	constructor(props) {
		super(props);

		this.state = {
			default: true,
		};
	}
	render() {
		return (
			<div className="frame visualisation">
				<div className="row title">
					<div className="columns ten"><h6>Visualisation</h6></div>
					<div className="columns two">
						<Button
							id="update-vis"
							onClick={() => this.props.dispatch(processFiles())}
						>
							Update
						</Button>
					</div>
				</div>
				<div className="row plot">
					<Loader loaded={!this.props.loading}>
						<Plot
							data={[{
								opacity: 0.7,
								type: 'scatter3d',
								x: this.props.xData,
								y: this.props.yData,
								z: this.props.zData,
								mode:'markers',
								"marker": {
									"colorbar": {
										"title": this.props.zLabel,
									},
									"color": this.props.zData,
									"colorscale": [
										[ 0, "#440154" ],
										[ 0.111111111111111, "#482878" ],
										[ 0.222222222222222, "#3E4A89" ],
										[ 0.333333333333333, "#31688E" ],
										[ 0.444444444444444, "#26838E" ],
										[ 0.555555555555556, "#1F9D89" ],
										[ 0.666666666666667, "#35B779" ],
										[ 0.777777777777778, "#6CCE59" ],
										[ 0.888888888888889, "#B4DD2C" ],
										[ 1,"#FDE725" ]
									]
								}
							}]}

							layout={{
								width: 1200,
								height: 800,
								autosize: true,
								scene:{
									aspectmode: "manual",
									aspectratio: {
										x: 1, y: 1, z: 1,
									},
									xaxis: {
										title: this.props.xLabel,
										nticks: 9,
										range: [this.props.xMin, this.props.xMax],//0, 10],
									},
									yaxis: {
										title: this.props.yLabel,
										nticks: 7,
										range: [this.props.yMin, this.props.yMax],//-2, 10],
									},
									zaxis: {
										title: this.props.zLabel,
										nticks: 10,
										range: [this.props.zMin, this.props.zMax],//-2, 10],
									}
								}
							}}
						/>
					</Loader>
				</div>
		</div >
		);
	}
}

GraphDisplay.propTypes = {
	xData: PropTypes.array,
	xMax: PropTypes.number,
	xMin: PropTypes.number,
	xLabel: PropTypes.string,

	yData: PropTypes.array,
	yMax: PropTypes.number,
	yMin: PropTypes.number,
	yLabel: PropTypes.string,

	zData: PropTypes.array,
	zMax: PropTypes.number,
	zMin: PropTypes.number,
	zLabel: PropTypes.string,
	
	loading: PropTypes.bool,
};;

export default GraphDisplay;


// WEBPACK FOOTER //
// ./src/components/GraphDisplay.js